import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState, useEffect } from "react";
import { id } from "date-fns/locale";
import FieldPelangganDialog from "../add/FieldPelangganDialog";
import FieldDeviceDialog from "../add/FieldDeviceDialog";

import Button from "@mui/material/Button";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";

import { axiosInstance as axios, endpoint } from "../../../../api/axios";
import { useSelector } from "react-redux";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from "notistack";
import format from 'date-fns/format';

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddServiceDialog = ({ redirect, openAddService, handleCloseAddService }) => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [openPelanggan, setOpenPelanggan] = useState(false);
  const [openDevice, setOpenDevice] = useState(false);
  const [selectedPelanggan, setSelectedPelanggan] = useState({id: null, name: ""});
  const [selectedDevice, setSelectedDevice] = useState({id: null, name: ""});

  const { enqueueSnackbar } = useSnackbar();

   

  const currentUserId = useSelector((state) => state.user.currentUserId);
  const user = useSelector(
    (state) => state.user.users[state.user.currentUserId]
  );

  const [dataKapasitas, setDataKapasitas] = useState([]);
  const [kapasitas, setKapasitas] = useState({ id: null, name: "" });

  const [warna, setWarna] = useState({ id: null, name: "" });
  const [dataWarna, setDataWarna] = useState([]);


  const [dataPelanggan, setDataPelanggan] = useState([]);

  const [dataMyDevice, setDataMyDevice] = useState([]);

  const [dataTemplateDevice, setDataTemplateDevice] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [serialNumber, setSerialNumber] = useState("");

  const [priority, setPriority] = useState({id: null, value:""});
  const [keterangan, setKeterangan] = useState("");
  const [kondisi, setKondisi] = useState(null);
  const [lokasi, setLokasi] = useState(null);

   // Skema validasi Yup
   const validationSchema = Yup.object({
    selectedPelanggan: Yup.object().shape({
      id: Yup.number().required('data ini wajib diisi'),
    }).required('data ini wajib diisi'),
    selectedDevice: Yup.object().shape({
      id: Yup.number().required('data ini wajib diisi'),
    }).required('data ini wajib diisi'),
    serialNumber: Yup.string().required('data ini wajib diisi'),
  });

  const formik = useFormik({
    initialValues: {
      selectedDateTime: format(new Date(), 'yyyy-MM-dd HH:mm'),
      selectedPelanggan: { id: null, name: ''  },
      selectedDevice: { id: null, name: ''},
      serialNumber: '',
      kapasitas: null,
      warna: null,
      priority: '',
      keterangan: '',
      kondisi: '0',
      lokasi: '1',
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        await axios.post(
          endpoint.Service.ServiceAdd,
          {
            date: values.selectedDateTime,
            customer_id: values.selectedPelanggan.id,
            device_id: values.selectedDevice.id,
            serial_number: values.serialNumber,
            storage_id: values.kapasitas.id,
            color_id: values.warna.id,
            priority: values.priority.id,
            notes: values.keterangan,
            conditions: values.kondisi,
            is_entrusted: values.lokasi,
          },
          {
            headers: {
              Authorization: `${user.token_type} ${user.token}`,
            },
          }
        );
        enqueueSnackbar('Berhasil Tambah Service!', { variant: 'success' });
        resetForm();
        handleCloseAddService();
        redirect();
      } catch (error) {
        console.log("Ini pesan eror add data service", error)
        enqueueSnackbar('Gagal Tambah Service!', { variant: 'error' });
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleSelectPelanggan = (pelanggan) => {
    setSelectedPelanggan(pelanggan);
    formik.setFieldValue('selectedPelanggan', pelanggan);
    formik.setFieldTouched('selectedPelanggan', true);
    setOpenPelanggan(false);
  };

  const handleSelectDevice = (device) => {
    setSelectedDevice(device);
    formik.setFieldValue('selectedDevice', device);
    formik.setFieldTouched('selectedDevice', true);
    setOpenDevice(false);
  };


  // Master Data Warna

  useEffect(() => {
    const getDataWarna = async () => {
      try {
        if (user?.token) {
          const response = await axios.post(
            endpoint.MasterDataService.Color,
            {
              page: currentPage,
              pageSize: pageSize,
            },
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            }
          );

          const data = response.data.data?.data;
          setDataWarna(data || []);
          setTotal(response.data.total);
        }
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
    getDataWarna();
  }, [currentPage, pageSize]);

  // Master Data Storage / Kapasitas

  useEffect(() => {
    const getDataKapasitas = async () => {
      try {
        if (user?.token) {
          const response = await axios.post(
            endpoint.MasterDataService.Storage,
            {
              page: currentPage,
              pageSize: pageSize,
            },
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            }
          );

          const data = response.data.data?.data;
          setDataKapasitas(data || []);
          setTotal(response.data.total);
        }
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
    getDataKapasitas();
  }, [currentPage, pageSize]);

  
  // Master Data Pelanggan

  useEffect(() => {
    const getDataPelanggan = async () => {
      try {
        if (user?.token) {
          const response = await axios.post(
            endpoint.MasterDataService.Customer,
            {
              page: currentPage,
              pageSize: pageSize,
            },
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            }
          );

          const data = response.data.data?.data;
          setDataPelanggan(data || []);
          setTotal(response.data.total);
        }
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
    getDataPelanggan();
 
  }, [selectedPelanggan, currentPage, pageSize]);



  // Master Data My Device

  useEffect(() => {
    const getDataMyDevice = async () => {
      try {
        if (user?.token) {
          const response = await axios.post(
            endpoint.MasterDataService.MyDevice,
            {
              page: currentPage,
              pageSize: pageSize,
            },
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            }
          );

          const data = response.data.data?.data;
          setDataMyDevice(data || []);
          setTotal(response.data.total);
        }
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
    getDataMyDevice();
 
  }, [selectedDevice, currentPage, pageSize]);


  // Master Data Template Device

  useEffect(() => {
    const getDataTemplateDevice = async () => {
      try {
        if (user?.token) {
          const response = await axios.post(
            endpoint.MasterDataService.TemplateDevice,
            {
              page: currentPage,
              pageSize: pageSize,
            },
            {
              headers: {
                Authorization: `${user.token_type} ${user.token}`,
              },
            }
          );

          const data = response.data.data?.data;
          setDataTemplateDevice(data || []);
          setTotal(response.data.total);
        }
      } catch (error) {
        console.error("Data gagal dieksekusi", error);
      }
    };
    getDataTemplateDevice();
 
  }, [selectedDevice, currentPage, pageSize]);



  // const optionsDevice = {
  //   "Device Saya": [
  //     { name: "iPhone 12", jenis: "Smartphone & Tablet" },
  //     { name: "Galaxy S21", jenis: "Smartphone & Tablet" },
  //     { name: "Xiaomi Note 10", jenis: "Smartphone & Tablet" },
  //   ],
  //   Template: [
  //     { name: "iPad Pro", jenis: "Smartphone & Tablet" },
  //     { name: "Galaxy Tab S7", jenis: "Smartphone & Tablet" },
  //     { name: "Huawei MatePad", jenis: "Smartphone & Tablet" },
  //   ],
  //   Manual: [],
  // };

  const handlePriorityChange = (e) => {
    const selectedValue = e.target.value;
    const selectedOption = priorityOptions.find(option => option.value === selectedValue);
    if (selectedOption) {
      formik.setFieldValue('priority', { id: selectedOption.id, value: selectedOption.value });
    }
  };


  const priorityOptions = [
    {
      id: '0',
      label: "Ringan",
      value: "ringan",
      icon: (
        <ArrowDropDownIcon
          sx={{
            color: "#2196f3", // biru
            bgcolor: "rgba(33, 150, 243, 0.1)",
            borderRadius: "50%",
            padding: "2px",
          }}
        />
      ),
    },
    {
      id: '1',
      label: "Sedang",
      value: "sedang",
      icon: (
        <HorizontalRuleIcon
          sx={{
            color: "#fbc02d", // kuning
            bgcolor: "rgba(251, 192, 45, 0.1)",
            borderRadius: "50%",
            padding: "2px",
          }}
        />
      ),
    },
    {
      id: '3',
      label: "Berat",
      value: "berat",
      icon: (
        <ArrowDropUpIcon
          sx={{
            color: "#f44336", // merah
            bgcolor: "rgba(244, 67, 54, 0.1)",
            borderRadius: "50%",
            padding: "2px",
          }}
        />
      ),
    },
  ];

  const handleOpenPelanggan = () => {
    setOpenPelanggan(true);
  };
  const handleClosePelanggan = () => {
    setOpenPelanggan(false);
  };

  const handleOpenDevice = () => {
    setOpenDevice(true);
  };
  const handleCloseDevice = () => {
    setOpenDevice(false);
  };

  // const handleSelectPelanggan = (pelanggan) => {
  //   setSelectedPelanggan(pelanggan); 
  //   setOpenPelanggan(false); 
  // };

  // const handleSelectDevice = (device) => {
  //   setSelectedDevice(device); 
  //   setOpenDevice(false); 
  // };

  const handleLokasiChange = (e) => {
    formik.setFieldValue('lokasi', e.target.checked ? '0' : '1');
  };

 
  return (
    <Dialog
      fullScreen
      open={openAddService}
      onClose={handleCloseAddService}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseAddService}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Tambahkan Service
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          {/* Baris utama (rounded dan text) */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#f8bbd0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
              }}
            ></Box>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Teknisi
              </Typography>
              <Typography
                variant="body2"
                color="text.primary"
                fontWeight="bold"
              >
                {user?.name ? user?.name : "-"}
              </Typography>
            </Box>
          </Box>

          {/* Baris baru di bawahnya */}
          {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <BusinessIcon sx={{ color: "#3f51b5", fontSize: 20, mr: 1 }} />
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              PT Solusi Teknologi
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <StoreIcon sx={{ color: "#3f51b5", fontSize: 20, mr: 1 }} />
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Citywalk Sudirman
            </Typography>
          </Box> */}
        </Box>

        <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={id}>
        <DateTimePicker
          label="Tanggal"
          value={formik.values.selectedDateTime ? new Date(formik.values.selectedDateTime) : null}
          onChange={(newValue) => {
            const adjustedDate = new Date(
              newValue.getTime() -
              newValue.getTimezoneOffset() * 60000 +
              7 * 60 * 60000
            );
            const formattedDate = format(adjustedDate, 'yyyy-MM-dd HH:mm');
            formik.setFieldValue('selectedDateTime', formattedDate);
          }}
          format="dd MMMM yyyy HH:mm"
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              variant: "outlined",
              placeholder: "Tanggal",
              sx: {
                mb: 2,
                bgcolor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              },
            },
          }}
        />
      </LocalizationProvider>

          <TextField
        fullWidth
        size="small"
        label="Pilih Pelanggan"
        placeholder="Pilih Pelanggan"
        value={selectedPelanggan?.name || ''}
        variant="outlined"
        onClick={handleOpenPelanggan}
        error={
          formik.touched.selectedPelanggan && Boolean(formik.errors.selectedPelanggan)
        }
        helperText={
          formik.touched.selectedPelanggan && formik.errors.selectedPelanggan?.id
        }
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end">
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          bgcolor: '#fff',
          borderRadius: 2,
          mb: 2,
          cursor: 'pointer',
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          },
        }}
      />

    <TextField
        fullWidth
        size="small"
        label="Pilih Device"
        placeholder="Pilih Device"
        value={selectedDevice?.name || ''}
        variant="outlined"
        onClick={handleOpenDevice}
        error={formik.touched.selectedDevice && Boolean(formik.errors.selectedDevice)}
        helperText={formik.touched.selectedDevice && formik.errors.selectedDevice?.id}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end">
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          bgcolor: '#fff',
          borderRadius: 2,
          mb: 2,
          cursor: 'pointer',
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          },
        }}
      />

          {/* Serial Number / IMEI */}
          <TextField
        fullWidth
        size="small"
        label="Serial Number"
        name="serialNumber"
        variant="outlined"
        value={formik.values.serialNumber}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.serialNumber && Boolean(formik.errors.serialNumber)}
        helperText={formik.touched.serialNumber && formik.errors.serialNumber}
        sx={{ mb: 2 }}
      />

          {/* Autocomplete Kapasitas */}
          <Autocomplete
            fullWidth
            size="small"
            options={dataKapasitas}
            value={formik.values.kapasitas}
            onChange={(e, value) => {
              formik.setFieldValue('kapasitas', value || { id: null, name: '' });
            }}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Kapasitas"
                placeholder="Pilih Kapasitas"
                variant="outlined"
              />
            )}
            sx={{
              bgcolor: "#fff",
              borderRadius: 2,
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />

          {/* Autocomplete Warna */}
          <Autocomplete
            fullWidth
            size="small"
            options={dataWarna}
            value={formik.values.warna}
        onChange={(e, value) => {
          formik.setFieldValue('warna', value || { id: null, name: '' });
        }}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Warna"
                placeholder="Pilih Warna"
                variant="outlined"
              />
            )}
            sx={{
              bgcolor: "#fff",
              borderRadius: 2,
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
          {/* Dropdown Prioritas */}
          <TextField
            select
            fullWidth
            size="small"
            label="Prioritas"
            value={formik.values.priority?.value || ''}
            onChange={handlePriorityChange}
            variant="outlined"
            sx={{
              bgcolor: "#fff",
              borderRadius: 2,
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          >
            {priorityOptions.map((option) => (
              <MenuItem key={option.id} value={option.value}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {option.icon}
                  <Typography>{option.label}</Typography>
                </Box>
              </MenuItem>
            ))}
          </TextField>

          {/* Textarea Keterangan */}
          <TextField
            fullWidth
            size="small"
            label="Keterangan"
            placeholder="keterangan "
            multiline
            rows={4}
            value={formik.values.keterangan || ''}
            onChange={(e) => formik.setFieldValue('keterangan', e.target.value)}
            variant="outlined"
            sx={{
              bgcolor: "#fff",
              borderRadius: 2,
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 4,
              flexWrap: "wrap",
            }}
          >
            {/* Kondisi - Kiri */}
            <FormControl component="fieldset">
            <FormLabel component="legend">Kondisi</FormLabel>
            <RadioGroup
              row
              value={formik.values.kondisi ?? ''}
              onChange={(e) => formik.setFieldValue('kondisi', parseInt(e.target.value, 10))}
            >
              <FormControlLabel value='0' control={<Radio color="primary" />} label="Nyala" />
              <FormControlLabel value='1' control={<Radio color="primary" />} label="Mati" />
            </RadioGroup>
          </FormControl>

            {/* Lokasi Barang - Checkbox */}
            <FormControl component="fieldset">
              <FormLabel component="legend">Lokasi Barang</FormLabel>
              <FormControlLabel
                control={
                  <Checkbox
                  checked={formik.values.lokasi === '0'}
                  onChange={handleLokasiChange}
                    color="primary"
                  />
                }
                label="Dititipkan"
              />
            </FormControl>
          </Box>
        </Box>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Button
            variant="contained"
             type="submit"
             disabled={formik.isSubmitting}
            fullWidth
            sx={{
              textTransform: "none",
              bgcolor: "#424242",
              borderRadius: 5,
              ":hover": {
                bgcolor: "#08306b",
              },
            }}
          >
           Simpan Data Service
          </Button>
        </Box>
        </form>
      </Box>
      
      <FieldPelangganDialog
        pageSize={pageSize}
        dataPelanggan={dataPelanggan}
        openPelanggan={openPelanggan}
        handleClosePelanggan={handleClosePelanggan}
        onSelect={handleSelectPelanggan}
      />

      <FieldDeviceDialog
        // dataDevice={optionsDevice}
        dataMyDevice={dataMyDevice}
        pageSize={pageSize}
        dataTemplateDevice={dataTemplateDevice}
        openDevice={openDevice}
        handleCloseDevice={handleCloseDevice}
        onSelect={handleSelectDevice}
      />
    </Dialog>
  );
};

export default AddServiceDialog;
